/**
 * © 2025 Little Shilling, Inc.
 * Shon Little
 * Created: 2025-10-13
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'fr'],
    defaultNS: 'common',
    ns: [
      'common',
      'auth',
      'studio',
      'billing',
      'dashboard',
      'errors',
      'navigation',
      'contact',
      'pricing',
      'home',
      'settings',
      'tools',
      'chatbot',
    ],

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'tools-dance-language',
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
